import { useMutation } from "@tanstack/react-query";
import { FormattedTagType } from "../../../modules/tagsAndMetadataTags/pages/TagsAndMetadataTags/Tabs/Content/Tags/components/TagDetails/context/types";
import { createThemeTagType } from "../api/createThemeTagType";
import { CreateThemeTagType } from "../types";
import { invalidateThemePrimaryTagsQuery } from "./useThemePrimaryTagsQuery";

type Params = {
  themeTagType: CreateThemeTagType;
  handleThemeTagType: (value: FormattedTagType) => void;
};

export const useCreateTagTypeMutation = () => {
  return useMutation({
    mutationFn: async ({ themeTagType, handleThemeTagType }: Params) => {
      const response = await createThemeTagType(themeTagType);
      return handleThemeTagType({
        id: response.id,
        name: response.name,
      });
    },
    onSuccess: (_) => {
      invalidateThemePrimaryTagsQuery();
    },
    onError: (e) => console.error(e),
  });
};
